// extracted by mini-css-extract-plugin
export default {"iconBase":"PlusIcon_iconBase__uRRu-"};